import "./polyfills";
import React from "react";
import ReactDOM from "react-dom";
import Popper from "popper.js";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import HttpsRedirect from "react-https-redirect";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { Provider } from "react-redux";
import store from "./store";
import UserProvider from "./auth/FirebaseUserProvider";

// Required to enable animations for dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;

Bugsnag.start({
  apiKey: "9f03b819478ca2055e273fc5e6f2d948",
  plugins: [new BugsnagPluginReact()],
});

const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);

const onRedirectCallback = (appState) => {
  window.history.replaceState(
    {},
    document.title,
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

const rootElement = document.getElementById("root");
ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <UserProvider>
        <HttpsRedirect>
          <App />
        </HttpsRedirect>
      </UserProvider>
    </Provider>
  </ErrorBoundary>,
  rootElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
